export default __webpack_public_path__ + "static/media/OwlPage1.2ae6828b.txt";